window.onload = function () {
  'use strict';
  window.onpopstate = function (event) {
    if (event.state !== null && event.state.paged) {
      console.log('PAGED: ' + document.location);
      let dummyEvent = {
        preventDefault() {
        },
        target: {
          getAttribute() {
            return document.location;
          }
        }
      };
      window.companyListPager.loadMoreCompanies(dummyEvent, false);
    } else {
      console.log('NORMAL: ' + document.location);
    }
    // window.location = document.location;
  };
  // window.onpopstate = function(event) {
  //   alert(`location: ${document.location}, state: ${JSON.stringify(event.state)}`)
  // }
  window.companyListPager = new Vue(
    {
      el: '#companyListContainer',
      data: {
        gettingCompanies: false,
        showMoreButtonDisplayStyle: {},
        currentHref: {},
        displayPrevLink: false,
        displayNextLink: false,
      },
      mounted() {
        let prevInit = document.getElementById('loadPrevLink').getAttribute('data-hide-on-init');
        let nextInit = document.getElementById('loadNextLink').getAttribute('data-hide-on-init');
        this.displayPrevLink = prevInit < 1;
        this.displayNextLink = nextInit < 1;
        // console.log('Pager->prevInit=' + prevInit);
        // console.log('Pager->displayPrevLink=' + this.displayPrevLink);
        // console.log('Pager->nextInit=' + nextInit);
        // console.log('Pager->displayNextLink=' + this.displayNextLink);

      },
      methods: {
        async loadMoreCompanies(event, writeHistory = true) {
          event.preventDefault();
          // block trigger happies
          if (this.gettingCompanies) {
            return;
          }
          this.gettingCompanies = true;

          this.currentHref = event.target.getAttribute('href');
          //console.log(event.target.getAttribute('href'));
          //console.log(event.target.parent().getAttribute('href'));
          if (this.currentHref == null) {
            this.currentHref = event.target.parentNode.getAttribute('href');
          }

          console.log('Pager->loadMoreCompanies: href=' + this.currentHref);

          this.showLoadingDiv(true);
          let response = await fetch(
            this.currentHref,
            {
              headers: new Headers({'x-requested-with': 'XMLHttpRequest'}), // request ajax results
              method: 'GET',
            }
          );


          let result = {};
          if (response.status === 200) {
            result = await response.json();
            // console.log('Pager->got companies successful');
            // replace companies
            document.getElementById('companyListHolder').innerHTML = result.pagedList;
            if (writeHistory) {
              window.history.pushState({paged: true}, 'cityguide', this.currentHref);
            }

            if (result.MoreThanOnePage > 0) {
              // console.log('Pager->MoreThanOnePage is true');
              if (result.HidePrevLink > 0) {
                // console.log('Pager->HidePrevLink is true');
                this.hidePrevLink();
              } else {
                // console.log('Pager->HidePrevLink is false');
                this.showPrevLink(result.PrevLink);
              }
              if (result.HideNextLink > 0) {
                // console.log('Pager->HideNextLink is true');
                this.hideNextLink(result.NextLink);
              } else {
                // console.log('Pager->HideNextLink is false');
                this.showNextLink(result.NextLink);
              }
            } else {
              // console.log('Pager->MoreThanOnePage is false');
              this.hidePrevLink();
              this.hideNextLink();
            }
          } else {
            console.warn('Pager->cannot get more companies.' + response.status + ': ' + response.statusText);
          }
          this.showLoadingDiv(false);
          this.gettingCompanies = false;
          document.getElementById('scrollBackToHereAfterNewCompaniesAreLoaded').scrollIntoView();
        },
        hidePrevLink() {
          // console.log('Pager->hidePrevLink');
          this.displayPrevLink = false;
        },
        showPrevLink(href) {
          // console.log('Pager->showPrevLink '+ href);
          this.displayPrevLink = true;
          document.getElementById('loadPrevLink').setAttribute('href', href);
        },
        hideNextLink() {
          // console.log('Pager->hideNextLink');
          this.displayNextLink = false;
        },
        showNextLink(href) {
          // console.log('Pager->showNextLink '+ href);
          document.getElementById('loadNextLink').setAttribute('href', href);
          this.displayNextLink = true;
        },

        showLoadingDiv: function (show) {
          if (show) {
            document.body.classList.add('cityguide-loading');
          } else {
            document.body.classList.remove('cityguide-loading');
          }
        },
      },
    }
  );
  window.companyListFilterBlock = new Vue(
    {
      el: '#letterBranchFilterContainer',
      data: {},
      methods: {
        async replaceCompanyList(event) {
          // console.log('Filter->replaceCompanyList');
          window.companyListPager.loadMoreCompanies(event);
        },
      },
    }
  );
};
